import React from "react";
import { CheckBadgeIcon } from "@heroicons/react/24/outline";
function SubmittedInquiryPopUp(props) {
  const { onClose } = props;

  const handleClose = () => {
    if (typeof onClose === "function") {
      onClose();
    }
  };
  return (
    // Your alert popup component JSX

    <div className="bg-white rounded-lg shadow lg:w-[480px] outline-none focus:rounded-lg focus:outline-none focus:ring-main-violate flex flex-col items-center justify-evenly h-[380px]">
      <CheckBadgeIcon
        width={"130px"}
        height={"130px"}
        className="text-main-violate"
      />
      <div className="text px-2 px-2">
        <p className="font-bold text-center text-lg mb-4">Thank You</p>
        <p className="text-center text-base">
          Your inquiry has been submitted successfully, we will contact you by email soon.
        </p>
      </div>

      <div className="flex mt-5 justify-center w-[100%]">
        <button
          className="hover:bg-violet-600 cursor-pointer bg-main-violate  px-4 py-2 text-[16px] leading-[22.4px] text-white font-semibold tracking-normal h-[46px] rounded-lg mt-5 disabled:bg-violet-300 disabled:cursor-not-allowed"
          type="submit"
          onClick={handleClose}
        >
          Close
        </button>
      </div>
    </div>
  );
}

export default SubmittedInquiryPopUp;
